module.exports = __webpack_public_path__ + "static/media/emme-home-1.ba2a77b3.jpg";